/* tslint:disable */
/* eslint-disable */
/**
 * Leads API
 * API for managing leads (potential customers from external sources)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeadListItemDto } from './LeadListItemDto';
import {
    LeadListItemDtoFromJSON,
    LeadListItemDtoFromJSONTyped,
    LeadListItemDtoToJSON,
    LeadListItemDtoToJSONTyped,
} from './LeadListItemDto';

/**
 * 
 * @export
 * @interface SearchLeadsResponse
 */
export interface SearchLeadsResponse {
    /**
     * Total number of leads matching the search criteria
     * @type {number}
     * @memberof SearchLeadsResponse
     */
    totalCount: number;
    /**
     * 
     * @type {Array<LeadListItemDto>}
     * @memberof SearchLeadsResponse
     */
    items: Array<LeadListItemDto>;
}

/**
 * Check if a given object implements the SearchLeadsResponse interface.
 */
export function instanceOfSearchLeadsResponse(value: object): value is SearchLeadsResponse {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function SearchLeadsResponseFromJSON(json: any): SearchLeadsResponse {
    return SearchLeadsResponseFromJSONTyped(json, false);
}

export function SearchLeadsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchLeadsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'items': ((json['items'] as Array<any>).map(LeadListItemDtoFromJSON)),
    };
}

export function SearchLeadsResponseToJSON(json: any): SearchLeadsResponse {
    return SearchLeadsResponseToJSONTyped(json, false);
}

export function SearchLeadsResponseToJSONTyped(value?: SearchLeadsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'items': ((value['items'] as Array<any>).map(LeadListItemDtoToJSON)),
    };
}

